import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import CheckBox from "../../../components/check-box";

import {
    clear_type_maintenance,
    createTypeMaintenance,
    CREATE_TYPE_MAINTENANCE,
    getAllTypeMaintenance,
    updateTypeMaintenance,
    UPDATE_TYPE_MAINTENANCE
} from "../../../redux/type_maintenance";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {getAllCategoryMaintenance} from "../../../redux/categories_maintenances";
import SelectInput from "../../../components/select";

const TypeMaintenance = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_type_maintenance = useSelector((state) => state.type_maintenance_module._get_all_type_maintenance);
    const _create_type_maintenance = useSelector((state) => state.type_maintenance_module._create_type_maintenance);
    const _update_type_maintenance = useSelector((state) => state.type_maintenance_module._update_type_maintenance);

    const _get_all_category_maintenance = useSelector((state) => state.category_maintenance_module._get_all_category_maintenance);

    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllTypeMaintenance(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_type_maintenance && _get_all_type_maintenance.data && _get_all_type_maintenance.data.datos) {
            setData(_get_all_type_maintenance.data.datos);
        }
    }, [_get_all_type_maintenance]);

    useEffect(() => {
        if (_get_all_category_maintenance && _get_all_category_maintenance.data && _get_all_category_maintenance.data.datos) {
            let array = _get_all_category_maintenance.data.datos.filter(x => x.activo === true);
            setCategories(array);
        }
    }, [_get_all_category_maintenance]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);
    const [categories, setCategories] = useState([]);

    const [form, setForm] = useState({
        nombre: "",
        descripcion: "",
        id_categoria: "",
        categoria: "",
        activo: true,
        id: 0
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_typemaintenance').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        dispatch(getAllCategoryMaintenance(token));
                        setModal(true);
                        setId(item.id);
                        if (item.id_categoria === "") {
                            document.getElementById("id_categoria").selectedIndex = 0;
                        }
                        setForm({...form, nombre: item.nombre, descripcion: item.descripcion, id_categoria: item.id_categoria, categoria: item.categoria, activo: item.activo});
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else if (e.target.name === 'id_categoria') {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_type_maintenance.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_type_maintenance(CREATE_TYPE_MAINTENANCE));
            dispatch(getAllTypeMaintenance(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_type_maintenance.status !== 0) {
            dispatch(clear_type_maintenance(CREATE_TYPE_MAINTENANCE));
            toast.error(_create_type_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_type_maintenance, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_type_maintenance.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_type_maintenance(UPDATE_TYPE_MAINTENANCE));
            dispatch(getAllTypeMaintenance(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_type_maintenance.status !== 0) {
            dispatch(clear_type_maintenance(UPDATE_TYPE_MAINTENANCE));
            toast.error(_update_type_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_type_maintenance, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_categoria === "") {
            toast.error("Debe seleccionar la categoría", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(createTypeMaintenance(token, form));
        } else {
            dispatch(updateTypeMaintenance(token, id, form));
        }
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Tipos de mantenimientos", link: "/tipos-mantenimientos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_typemaintenance').length > 0 ?
                                        <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                            dispatch(getAllCategoryMaintenance(token));
                                            setForm({...form, descripcion: '', nombre: '', id_categoria: '', categoria: ''});
                                            document.getElementById("id_categoria").selectedIndex = 0;
                                            setId(0);
                                            setModal(true);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Descripción",
                                                type: "text",
                                            },
                                            {
                                                name: "categoria",
                                                label: "Categoría",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Tipo de mantenimiento</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Input
                                    id="nombre"
                                    name="nombre"
                                    label="Nombre"
                                    onChange={handleChange}
                                    value={form.nombre}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    id="descripcion"
                                    name="descripcion"
                                    label="Descripción"
                                    onChange={handleChange}
                                    value={form.descripcion}
                                />
                            </div>
                            <div className="form-group">
                                <label>Categoría</label>
                                <SelectInput
                                    label="Categoría"
                                    id="id_categoria"
                                    name="id_categoria"
                                    options={categories.map((item) => ({
                                        name: item.descripcion,
                                        id: item.id,
                                    }))}
                                    select={form.categoria}
                                    onChange={handleChange}
                                />
                            </div>
                            {(id !== 0) &&
                                <div className="form-group">
                                    <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                              state={form.activo}/>
                                </div>
                            }
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default TypeMaintenance;
